import { render, staticRenderFns } from "./PlayersTableControls.vue?vue&type=template&id=25ff16b7&"
import script from "./PlayersTableControls.vue?vue&type=script&lang=js&"
export * from "./PlayersTableControls.vue?vue&type=script&lang=js&"
import style0 from "./PlayersTableControls.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports